import React, { FC } from 'react';
import { useApplication } from '../../../../context/ApplicationContext';
import { get } from 'lodash';

import Schema from '../../../../lib/paths/antrag_FULL_Paths.json';
import { Breadcrumbs, Typography } from '@mui/material';
import { enumT } from '../../../../utils/helper';
const P = Schema.attributes;

const BreadcrumbSkizze: FC<{}> = () => {
	const { application } = useApplication();

	return (
		<>
			<Breadcrumbs separator="›" aria-label="breadcrumb" sx={{ maxWidth: '81.875rem'}}>
				<Typography color="secondary">Mein Bereich</Typography>
				<Typography color="secondary">Förderungen</Typography>
				<Typography color="secondary">{enumT(get(application, P.Allgemein_Typ.path, ''))}</Typography>
				<Typography color="primary">{get(application, P.Allgemein_Projekttitel.path, '*')}</Typography>
			</Breadcrumbs>
		</>
	);
};

export default BreadcrumbSkizze;
